import { render, staticRenderFns } from "./IconInfoSmall.vue?vue&type=template&id=3c1eb562&"
import script from "./IconInfoSmall.vue?vue&type=script&lang=js&"
export * from "./IconInfoSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports